import { useState } from 'react';

import { LegacyReferralsTable } from './LegacyReferralsTable';
import { QueryDataTableFilterBar } from '~/shared/data-tables/query/QueryDataTableFilterBar';
import { useQueryDataTableOptions } from '~/shared/data-tables/query/useQueryDataTableOptions';
import { AreaFilter, CreatedSinceFilter, getReferralViewFilters, ReferralStatusFilter, referralViews, refreshIntervals } from './ReferralsFilters';
import { NewLegacyReferralFormModal } from '../NewLegacyReferralFormModal';
import { useIdentity } from '~/features/authentication/identity/IdentityContext';
import { useQueryClient } from '@tanstack/react-query';
import { getSearchQueryKey } from '~/util/http/useSearch';
import { Button } from '~/shared/components/buttons/Button';
import { FilterBar } from '~/shared/components/filter-bar/FilterBar';
import { SelectField } from '~/shared/forms/controls/base-fields/SelectField';
import { parseAsString, useQueryState } from 'nuqs';

export function AllLegacyReferrals() {
	const { loggedInUser } = useIdentity();
	const [displayNewReferralModal, setDisplayNewReferralModal] = useState(false);
	const [refreshInterval, setRefreshInterval] = useState(0);
	const [view, setView] = useQueryState('referralView', parseAsString.withDefault(referralViews[0].id));
	const { setSearchOptions } = useQueryDataTableOptions();
	const queryClient = useQueryClient();

	const onRefresh = () => {
		queryClient.invalidateQueries({ queryKey: getSearchQueryKey('legacy-referral') });
	};

	return (
		<div className="space-y-6">
			<div className="flex items-center justify-end gap-4">
				<SelectField
					label="Auto Refresh"
					hideLabel
					value={refreshInterval}
					onChange={x => setRefreshInterval(Number(x ?? 0))}
					items={refreshIntervals}
				/>
				<Button actionType="add" onClick={() => setDisplayNewReferralModal(true)} label="New Referral" />
				{displayNewReferralModal && <NewLegacyReferralFormModal closeModal={() => setDisplayNewReferralModal(false)} />}
			</div>

			<QueryDataTableFilterBar onRefresh={onRefresh}>
				<FilterBar.Item label="Show">
					<SelectField
						label="Show"
						hideLabel
						value={view}
						onChange={x => {
							setView(x ? String(x) : null);
							setSearchOptions(y => ({ ...y, page: 1 }));
						}}
						items={referralViews}
					/>
				</FilterBar.Item>
				<FilterBar.Item label="Created Since">
					<CreatedSinceFilter />
				</FilterBar.Item>
				<FilterBar.Item label="Status">
					<ReferralStatusFilter />
				</FilterBar.Item>
				<FilterBar.Item label="Area">
					<AreaFilter />
				</FilterBar.Item>
			</QueryDataTableFilterBar>
			<LegacyReferralsTable
				staticFilters={getReferralViewFilters(view, loggedInUser.id)}
				refetchInterval={refreshInterval > 0 ? refreshInterval : false}
			/>
		</div>
	);
}
